/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react'
import makeStyles from '@material-ui/styles/makeStyles'
import Paper from '@material-ui/core/Paper';
import FormControl from '@material-ui/core/FormControl';
import InputAdornment from '@material-ui/core/InputAdornment';
import TextField from '@material-ui/core/TextField';
import { array, bool, func, object, string } from 'prop-types';
import { useUIDSeed } from 'react-uid';


const useStyles = (mobile, isDadJokeGPT) => makeStyles((theme) => ({
    cardContainer: {
        display: 'relative',
        width: '100%',
    },
    card: {
        width: '100%',
        padding: '15px 20px',
        margin: '24px 0',
        boxShadow: `0px 0px 5px rgba(47, 47, 47, 0.25)`,
        borderRadius: '8px',
        color: `${theme.palette.common.black} !important`,
    },
    title: {
        textAlign: 'center',
        fontWeight: 700,
        fontSize: `${mobile ? '18px' : '20px'} !important`,
        lineHeight: '26px',
        marginBottom: '25px !important',
    },
    input: {
        height: '50px',
        width: '100%',
        marginBottom: '16px',
        backgroundColor: '#F5F5F5',
        border: '1px solid #E9E9E9',
        borderRadius: '4px',
    },
    adornment: {
        position: 'relative',
        height: '100%',
        textAlign: 'center',
        fontWeight: 500,
        fontSize: '16px !important',
        color: `${isDadJokeGPT ? '#081E3F' : theme.palette.common.black}`,
        fontFamily: 'Roboto, sans-serif !important',
    },
    textFieldInput: {
        fontSize: '16px !important',
        lineHeight: '24px',
        color: `${theme.palette.common.black} !important`,
    }
}));

const CardWithInput = (props) => {
    const classesLayout = useStyles(props.mobile, props.isDadJokeGPT);
    const classes = classesLayout();

    const seed = useUIDSeed();

    const handleFormChange = (e) => {
        const { name, value } = e.target;
        props.handleOptionChange(name, value);
    }

    return (
        <Paper className={classes.card}>
            <FormControl className={classes.cardContainer}>
                <p className={classes.title}>{props.title}</p>
                {Object.keys(props.options.whoLikes).map((value, index) => (
                    <TextField
                        key={`field${seed(value)}`}
                        className={classes.input}
                        value={props.selections[value]}
                        name={value}
                        autoComplete='off'
                        placeholder={props.placeholders?.[index] || ''}
                        onChange={(e) => handleFormChange(e)}
                        InputProps={{
                            style: {
                                fontSize: '16px',
                                height: '50px',
                                width: '100%',
                                padding: '0 14px',
                            },
                            startAdornment: (
                                <InputAdornment className={classes.adornment} position="start">
                                    <span>{index + 1}.</span>
                                </InputAdornment>
                            ),
                            disableUnderline: true,
                            classes: {
                                input: classes.textFieldInput,
                            },
                        }}
                    />
                ))}
            </FormControl>
        </Paper>
    )
}

CardWithInput.defaultProps = {
    title: '',
    options: {},
    selections: {},
}

CardWithInput.propTypes = {
    title: string.isRequired,
    options: object.isRequired,
    selections: object.isRequired,
    handleOptionChange: func.isRequired,
    mobile: bool.isRequired,
    placeholders: array.isRequired,
    isDadJokeGPT: bool.isRequired,
}

export default CardWithInput